import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import "@babel/polyfill";
import App from './App';
import * as serviceWorker from './serviceWorker';
import appAxios from './axios/appAxios';
import config from 'react-global-configuration';
import store from './redux/store';
import * as currentUserActionConst from './redux/currentUser/actions';
import { Provider } from 'react-redux';
import { IENotSupport, StartupSpinner, CannotGetAuth, CannotGetConfig, CannotGetUserData } from './containers/IndexDisplay/IndexDisplay';
import { isIE } from 'react-device-detect';
import env from './env-config';

let wasteAppBaseName = env.REACT_APP_BASE_NAME;
let wasteAppBaseUrl = env.REACT_APP_BASE_URL;
let wasteApiBaseUrl = env.REACT_APP_API_BASE_URL;
let enviroment = env.REACT_APP_ENVIROMENT;

const root = document.getElementById('root');

let fnInitialConfiguration = async () => {

    try {

        let configuration = (await appAxios.get('/api/Management/Configuration/All')).data;

        let appConfig = {};
        configuration.map((item) => { appConfig[item.name] = item.value; });

        let langEn = (await appAxios.get('/api/i18n?langKey=en')).data;
        let langTh = (await appAxios.get('/api/i18n?langKey=th')).data;

        config.set({
            wasteAppBaseName,
            wasteAppBaseUrl,
            wasteApiBaseUrl,
            appConfig,
            enviroment,
            langEn,
            langTh
        });

        /* Set System Configuration
            * Used:
            *     1. import config from 'react-global-configuration';
            *     2. let variable = config.get("configKey");
            */

        let redirectUrl = sessionStorage.getItem("SCGChem.PMM.WasteMgnt.WebUI.RedirectUrl");
        if (redirectUrl) {
            sessionStorage.removeItem("SCGChem.PMM.WasteMgnt.WebUI.RedirectUrl");
            window.location = redirectUrl;
        } else {
            ReactDOM.render(<Provider store={store}><App /></Provider>, root);

        }
    }
    catch (error) {
        console.log(error);

        ReactDOM.render(<CannotGetConfig />, root);
    }
}

let fnInitialApplication = async () => {

    if (isIE) {
        ReactDOM.render(<IENotSupport />, root);
    }
    else {
        ReactDOM.render(<StartupSpinner />, root);

        let meResp = await appAxios.get("/api/account/me");

        if (meResp.data == null) {
            localStorage.removeItem('SCGChem.PMM.WasteMgnt.WebUI.token');
            let meDMResp = await appAxios.get("/api/account/meDomainName");
            ReactDOM.render(<CannotGetUserData username={meDMResp.data} />, root);
        } else {
            store.dispatch({ type: currentUserActionConst.SET_USER, payload: meResp.data });
            fnInitialConfiguration();
        }
    }
}

fnInitialApplication();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
//serviceWorker.register();
